export const QUEST_TYPE = {
  SOCIAL_CONNECTION: "social_connection",
  TRADING_VOLUME: "trading_volume",
  CEX_CONNECTION: "cex_connection",
  TMA_TON_CONNECTION: "tma_ton_connection",
  TMA_FIRST_CEX_CONNECTION: "tma_first_cex_connection",
  SPINNING_WHEEL: "spinning_wheel",
  USER_AFFILIATED: "user_affiliated",
  TWITTER_LIKE_POST: "twitter_like_post",
  TWITTER_FOLLOW_ACCOUNT: "twitter_follow_account",
  TWITTER_RETWEET_POST: "twitter_retweet_post",
  TWITTER_COMMENT_POST: "twitter_comment_post",
  TWITTER_SEND_POST: "twitter_send_post",
  KYC_AND_TRADING: "kyc_and_trading",
  ARENA_MATCHES: "arena_matches",
  ARENA_BUY_IN_VOLUME: "arena_buy_in_volume",
} as const;
export type QUEST_TYPE = (typeof QUEST_TYPE)[keyof typeof QUEST_TYPE];

export const TMA_QUEST_TYPES = [QUEST_TYPE.TMA_TON_CONNECTION, QUEST_TYPE.TMA_FIRST_CEX_CONNECTION] as QUEST_TYPE[];
/**
 * Types the Arena quest board lists. `ARENA_BUY_IN_VOLUME` is left out on purpose: the
 * referee bonus is earned through the referral funnel, and listing filters on the types
 * the caller asks for, so omission here is what hides it.
 */
export const ARENA_QUEST_TYPES = [QUEST_TYPE.ARENA_MATCHES] as QUEST_TYPE[];
export const X_QUEST_TYPES = [
  QUEST_TYPE.TWITTER_LIKE_POST,
  QUEST_TYPE.TWITTER_FOLLOW_ACCOUNT,
  QUEST_TYPE.TWITTER_RETWEET_POST,
  QUEST_TYPE.TWITTER_COMMENT_POST,
  QUEST_TYPE.TWITTER_SEND_POST,
] as QUEST_TYPE[];

export const QUEST_REWARD_TYPE = {
  LOTTERY_TICKET: "lottery_ticket",
  USDT: "usdt",
  SPINNING_WHEEL_TICKET: "spinning_wheel_ticket",
  ARENA_TICKETS: "arena_tickets",
} as const;
export type QUEST_REWARD_TYPE = (typeof QUEST_REWARD_TYPE)[keyof typeof QUEST_REWARD_TYPE];

/** Which product surface a quest belongs to. Filters every public quest listing. */
export const QUEST_APP = {
  HUB: "hub",
  ARENA: "arena",
} as const;
export type QUEST_APP = (typeof QUEST_APP)[keyof typeof QUEST_APP];

/** `auto_grant` skips the claim step: rewards are released the moment the quest completes. */
export const QUEST_REWARD_DISTRIBUTION = {
  CLAIMABLE: "claimable",
  AUTO_GRANT: "auto_grant",
} as const;
export type QUEST_REWARD_DISTRIBUTION = (typeof QUEST_REWARD_DISTRIBUTION)[keyof typeof QUEST_REWARD_DISTRIBUTION];

/** What the completion window is measured from — the quest's own start, or each user's signup. */
export const QUEST_WINDOW_ANCHOR = {
  QUEST_START: "quest_start",
  USER_SIGNUP: "user_signup",
} as const;
export type QUEST_WINDOW_ANCHOR = (typeof QUEST_WINDOW_ANCHOR)[keyof typeof QUEST_WINDOW_ANCHOR];

/** Which settled arena entries count toward an `arena_matches` quest. */
export const ARENA_MATCH_OUTCOME = {
  PLAYED: "played",
  WON: "won",
} as const;
export type ARENA_MATCH_OUTCOME = (typeof ARENA_MATCH_OUTCOME)[keyof typeof ARENA_MATCH_OUTCOME];

export const ARENA_MATCH_TIER = {
  PAID: "paid",
  FREE: "free",
  ANY: "any",
} as const;
export type ARENA_MATCH_TIER = (typeof ARENA_MATCH_TIER)[keyof typeof ARENA_MATCH_TIER];

export const QUEST_SOCIAL = {
  X: "x",
  TELEGRAM: "telegram",
  DISCORD: "discord",
} as const;
export type QUEST_SOCIAL = (typeof QUEST_SOCIAL)[keyof typeof QUEST_SOCIAL];

export const QUEST_FREQUENCY = {
  ONCE: "once",
  DAILY: "daily",
  WEEKLY: "weekly",
  BIWEEKLY: "biweekly",
  MONTHLY: "monthly",
} as const;
export type QUEST_FREQUENCY = (typeof QUEST_FREQUENCY)[keyof typeof QUEST_FREQUENCY];

export const SPINNING_WHEEL_TYPE = {
  TMA_ONBOARDING: "tma_onboarding",
} as const;
export type SPINNING_WHEEL_TYPE = (typeof SPINNING_WHEEL_TYPE)[keyof typeof SPINNING_WHEEL_TYPE];
